import script from "./inbox-filtered-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./inbox-filtered-panel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__